export default {
  primary: "#2196F3",
  secondary: "#2b2b2b",
  danger: "#dc143c",
  warning: "#ffa500",
  success: "#659211",
};
